export const CONTACT_HISTORY_EDIT_WINDOW_MS = 60 * 60 * 1000;

export const isWithinContactHistoryEditWindow = (createdAt: string, now = Date.now()): boolean => {
  const createdAtMs = Date.parse(createdAt);
  return Number.isFinite(createdAtMs) && now < createdAtMs + CONTACT_HISTORY_EDIT_WINDOW_MS;
};
